import { Box, Typography } from '@mui/material';

const DigitalBalanceDisabledBanner = ({ text }: { text: string }) => {
	return (
		<Box
			sx={{
				position: 'relative',
			}}
		>
			<Box
				style={{
					paddingLeft: '13px',
					paddingRight: '13px',
				}}
				sx={{
					//width: '565px',
					height: '38px',
					background: '#FFAE2C',
					boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)',
					borderRadius: '0px 0px 10px 10px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-start',
					position: 'relative',

					/*
					TODO: curre	ntly we don't have a triangle on the banner, but if Barak will require it, we can add it here
					// '&::before': {
					// 	content: '""',
					// 	position: 'absolute',
					// 	top: '-4.4px',
					// 	left: '50%',
					// 	width: '28px',
					// 	height: '28px',
					// 	background: '#FFAE2C',
					// 	transform: 'translateX(-50%) rotate(-45deg)',
					// },
					*/
				}}
			>
				<Typography
					style={{
						textAlign: 'right',
					}}
					sx={{
						fontFamily: 'RubikSemiBold',
						fontWeight: '600',
						fontSize: '14px !important',
						lineHeight: '20px',
						letterSpacing: '0px',

						color: 'black',
						zIndex: 1,
						position: 'relative',
					}}
				>
					{text}
				</Typography>
			</Box>
		</Box>
	);
};

export default DigitalBalanceDisabledBanner;
